// assets
import {
  ContactsOutlined,
  EnvironmentOutlined,
  TeamOutlined
} from '@ant-design/icons';

// icons
const icons = {
  ContactsOutlined,
  EnvironmentOutlined,
  TeamOutlined
};

// ==============================|| MENU ITEMS - BASE DE DATOS ||============================== //

const pages = {
  id: 'authentication',
  title: 'Base de Datos',
  type: 'group',
  children: [
    {
      id: 'clientes',
      title: 'Clientes',
      type: 'item',
      url: '/clientes',
      icon: icons.ContactsOutlined
    }
    ,
    {
      id: 'baseGeneral',
      title: 'Base General',
      type: 'item',
      url: '/baseGeneral',
      icon: icons.TeamOutlined
    },
    {
      id: 'rutas',
      title: 'Rutas',
      type: 'item',
      url: '/rutas',
      icon: icons.EnvironmentOutlined
    },
    {
      id: 'usuarios',
      title: 'Usuarios',
      type: 'item',
      url: '/usuarios',
      icon: icons.TeamOutlined
    }
    ,
    {
      id: 'bancos',
      title: 'Bancos',
      type: 'item',
      url: '/bancos',
      icon: icons.TeamOutlined
    }
     ,
    {
      id: 'bases',
      title: 'Bases',
      type: 'item',
      url: '/bases',
      icon: icons.TeamOutlined
    }
  ]
};

export default pages;
